import { Inject, Injectable } from '@angular/core';
import { IconSetService } from '@coreui/icons-angular';
import {
  cidCloudDownload,
  cilAccountLogout,
  cilActionRedo,
  cilArrowLeft, cilArrowRight, cilBell, cilBoatAlt, cilBuilding, cilBuildingBusiness, cilCalendar, cilCalendarEvent,
  cilCart,
  cilChart,
  cilBadge,
  cilBan,
  cilBullhorn,
  cilChatBubble,
  cilCheck,
  cilCheckAlt,
  cilCompass,
  cilCheckCircle,
  cilChevronLeft, cilChevronRight,
  cilClock,
  cilCloudDownload,
  cilCloudUpload,
  cilColorPalette,
  cilCopy, cilCreditCard,
  cilDescription,
  cilDocument,
  cilDollar,
  cilDrop, cilEnvelopeClosed, cilEnvelopeOpen, cilExclamationCircle, cilExternalLink, cilEye, cilEyeSlash, cilFile, cilFolderOpen, cilFingerprint, cilGlobeAlt, cilGraph, cilGroup, cilHeart, cilHistory, cilInstitution, cilLightbulb,
  cilHome,
  cilImage,
  cilInfo,
  cilKey,
  cilLanguage,
  cilLink,
  cilLinkAlt,
  cilList,
  cilLocationPin,
  cilLockLocked, cilLockUnlocked, cilMediaPlayCircle,
  cilGift,
  cilMedicalCross,
  cilMenu, cilMinus,
  cilMoney,
  cilNotes,
  cilPencil, cilPeople,
  cilPhoneCallEnd,
  cilPlus, cilPuzzle,
  cilQrCode,
  cilReload,
  cilRoom,
  cilSchool,
  cilSearch,
  cilSettings,
  cilShieldAlt, cilShieldCheck,
  cilSitemap,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilSync,
  cilTrash,
  cilUser, cilUserFollow,
  cilUserUnfollow, cilUserX,
  cilWallet,
  cilWarning,
  cilX, cilXCircle, cisCloudDownload, cisGlobe,
  cilBeaker, cilRestaurant, cilRunning
} from '@coreui/icons-pro';
import { Logo, LOGO } from 'shared';
import { arrowDown, arrowLeft, arrowRight, arrowUp, cryptoWallet, info, moreVert } from '../assets/icons';


@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(private iconSetService: IconSetService,
    @Inject(LOGO) protected logo: Logo) { }
  // NOTE: icons with keys containing '-' are ignored e.g.:
  // { ... app-logo: logo, ...}
  // and <svg cIcon name="logo"></svg> 
  // will not work
  initializeIcons() {
    const logo = this.logo.value;
    const logoName: string = this.logo.name || 'logo';
    this.iconSetService.icons = {
      cilAccountLogout,
      cilSpeedometer,
      cilDrop,
      cilPencil,
      cilBan,
      cilPuzzle,
      cilMenu,
      cilBell,
      cilList,
      cilEnvelopeOpen,
      cilUser,
      cilUserFollow,
      cilUserUnfollow,
      cilUserX,
      cilLanguage,
      cilBoatAlt,
      cilBuilding,
      cilBuildingBusiness,
      cilGraph,
      cilPeople,
      cilCart,
      cilCreditCard,
      cilDollar,
      cilGlobeAlt,
      cilMinus,
      cilPlus,
      cilCheck,
      cilCheckAlt,
      cilCheckCircle,
      cilCompass,
      cilGift,
      cilMedicalCross,
      cilX,
      cilXCircle,
      cilChevronLeft,
      cilChevronRight,
      cilCopy,
      cilCloudDownload,
      cilImage,
      cilMediaPlayCircle,
      cilCalendar,
      // Community Network group icons (CommunitySeeder)
      cilBadge,
      cilBullhorn,
      cilHeart,
      cilInstitution,
      cilLightbulb,
      cilChatBubble,
      cilGroup,
      cilCalendarEvent,
      cilKey,
      cilArrowLeft,
      cilArrowRight,
      cilSchool,
      cilShieldAlt,
      cilShieldCheck,
      cilHistory,
      cilDocument,
      cilNotes,
      cilActionRedo,
      cilLink,
      cilLinkAlt,
      cilLockLocked,
      cilLockUnlocked,
      cilEye, 
      cilEyeSlash,
      cilEnvelopeClosed,
      cilQrCode,
      arrowUp,
      arrowRight,
      arrowDown,
      arrowLeft,
      cidCloudDownload,
      cisGlobe,
      cisCloudDownload,
      cilCloudUpload,
      cilColorPalette,
      cilClock,
      cilDescription,
      cilExternalLink,
      cilPhoneCallEnd,
      cilRoom,
      // Sales Toolkit admin menu entry
      cilFolderOpen,
      // Assistant menu entries (Global Health NutriGuide / BodyIQ / BioTune)
      cilRestaurant,
      cilRunning,
      cilBeaker,
      // [logoName]: logo,
      logo,
      cilWallet,
      cilWarning,
      cilMoney,
      cilChart,
      cilSitemap,
      cilSearch,
      cilSync,
      cilSpeech,
      cilSettings,
      cilReload,
      cilHome,
      cilLocationPin,
      cryptoWallet,
      cilInfo,
      cilStar,
      cilExclamationCircle,
      cilFile,
      cilFingerprint,
      cilTrash,
      info,
      moreVert
    };
  }
}
